import type { OnInit } from '@angular/core'
import { Component, DestroyRef, inject, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { filter, map, merge, switchMap } from 'rxjs'

@Component({
  selector: 'dhp-site-banner',
  templateUrl: './site-banner.component.html',
  imports: [RouterLink, TranslatePipe],
})
export class SiteBannerComponent implements OnInit {
  readonly showBanner = signal(false)
  router = inject(Router)
  route = inject(ActivatedRoute)
  private destroyRef = inject(DestroyRef)

  ngOnInit(): void {
    merge(
      // Handle query parameters on page load
      this.route.root.queryParams,

      // Handle query parameters on navigation
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        switchMap(() => this.route.root.queryParams)
      )
    )
      .pipe(
        map(params => params['banner'] === 'oldsite'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(show => {
        this.showBanner.set(show)
      })
  }
}
